module.exports = __webpack_public_path__ + "img/dec29_1.11410b73.jpg";